"use client"

import { useState, useEffect } from "react"
import reviewsData from "../data/reviews.json"
import "./Reviews.css"

const Reviews = () => {
  const [selectedReviews, setSelectedReviews] = useState([])

  useEffect(() => {
    const getFilteredReviews = () => {
      const filteredReviews = reviewsData.filter((review) => review.review_text && review.review_text.length > 100)
      const shuffledReviews = filteredReviews.sort(() => 0.5 - Math.random())
      return shuffledReviews.slice(0, 5)
    }

    setSelectedReviews(getFilteredReviews())
  }, [])

  return (
    <section className="reviews_section layout_padding">
      <div className="container">
        <div className="section-header">
          <h1 className="section_title">What Our Patients Say</h1>
          <p className="section_subtitle">Real experiences from our valued patients</p>
        </div>
      </div>
      <div className="container">
        <div id="customCarousel2" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            {selectedReviews.map((review, index) => (
              <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                <div className="review-card">
                  <div className="review-header">
                    <div className="review-author">
                      <div className="author-avatar">{review.name.charAt(0)}</div>
                      <div className="author-info">
                        <h5 className="author-name">{review.name}</h5>
                        <div className="review-rating">
                          {Array.from({ length: 5 }).map((_, starIndex) => (
                            <i
                              key={starIndex}
                              className={`fa ${starIndex < review.review_rating ? "fa-star" : "fa-star-o"}`}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="quote-icon">
                      <i className="fa fa-quote-right" />
                    </div>
                  </div>

                  <h4 className="review-title">{review.author_title}</h4>
                  <p className="review-text">{review.review_text}</p>

                  {review.owner_answer && (
                    <div className="owner-reply">
                      <div className="reply-header">
                        <i className="fa fa-reply"></i>
                        <strong>Our Response</strong>
                      </div>
                      <p>{review.owner_answer}</p>
                    </div>
                  )}

                  <a href={review.review_link} target="_blank" rel="noopener noreferrer" className="btn-review-link">
                    View Full Review <i className="fa fa-external-link"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#customCarousel2"
            data-bs-slide="prev"
          >
            <span className="carousel-control-icon">
              <i className="fa fa-chevron-left"></i>
            </span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#customCarousel2"
            data-bs-slide="next"
          >
            <span className="carousel-control-icon">
              <i className="fa fa-chevron-right"></i>
            </span>
            <span className="visually-hidden">Next</span>
          </button>

          <div className="carousel-indicators">
            {selectedReviews.map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#customCarousel2"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : "false"}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Reviews
